import { useRouter } from "next/router";
import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { cleanUpLabel } from "scmp-app/components/entity-oneline-menu/helper";
import {
  Container,
  MenuItem,
  StyledEntityLink,
} from "scmp-app/components/entity-oneline-menu/styles";
import type { entityOnelineMenuLiteQueueItemsEdge$key } from "scmp-app/queries/__generated__/entityOnelineMenuLiteQueueItemsEdge.graphql";

import { StyledSwiper, StyledSwiperSlide } from "./styles";

type Props = {
  className?: string;
  onClick?: (itemLabel: string) => void;
  reference: entityOnelineMenuLiteQueueItemsEdge$key;
  showTitle?: boolean;
};

export const EntityOnelineMenuLite: FunctionComponent<Props> = ({
  className,
  onClick,
  reference,
  showTitle = false,
}) => {
  const { query } = useRouter();
  const items = useFragment(
    graphql`
      fragment entityOnelineMenuLiteQueueItemsEdge on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Topic {
            name
            urlAlias
          }
          ... on Section {
            name
            urlAlias
            urlRedirect {
              toUrl
            }
          }
          ... on VideoSection {
            name
            urlAlias
            urlRedirect {
              toUrl
            }
          }
          ...entityLink
        }
      }
    `,
    reference,
  );

  if (items.length === 0) return null;

  return (
    <Container className={className}>
      <StyledSwiper cssMode={false} navigation={false} pagination={false} slidesPerView="auto">
        {showTitle && <StyledSwiperSlide>Related Topics:</StyledSwiperSlide>}
        {items.map(({ node }, index) => {
          const url = node.urlRedirect?.toUrl ?? node.urlAlias;
          return (
            <StyledSwiperSlide key={index}>
              <StyledEntityLink
                onClick={() => {
                  onClick?.(cleanUpLabel(node.name));
                }}
                reference={node}
              >
                <MenuItem data-active={query.asPath === url}>{cleanUpLabel(node.name)}</MenuItem>
              </StyledEntityLink>
            </StyledSwiperSlide>
          );
        })}
      </StyledSwiper>
    </Container>
  );
};

EntityOnelineMenuLite.displayName = "EntityOnelineMenuLite";
